import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site-info";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a
                href={siteInfo.social.weibo}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href={siteInfo.social.douban}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer"
                aria-label="豆瓣"
              >
                <i className="ri-movie-2-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteInfo.name}. 本站为非商业性质的电影内容分享平台。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>京ICP备XXXXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}